import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import Header from '../../../components/header/Header';
import useDocumentTitle from '../../../components/useDocumentTitle';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
import config from '../../../config'
import axios from 'axios';
import userContext from '../../../context/user/userContext'
import { useContext } from 'react';

const Login = () => {
  let {userState, updateUserState} = useContext(userContext)
  console.log(userState)
  useDocumentTitle('Login ');
  const notify = () => toast.success('Your account is  verified ');

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");

 const login = async ()=>{
      let response = await axios.post(config.BACKEND.URL+"/user/auth/signin",{
        email,
        password
      },{
        headers:{
        'x-api-key':'meritverse',
      }
    })
    console.log(response.data)
    if(response.data.success){
      updateUserState({
        ...userState,
        profile:response.data.result.user,
        loggedIn:true,
        token:response.data.result.token,
        userId:response.data.result.user._id
      })
      localStorage.setItem("token",response.data.result.token);
      localStorage.setItem("userId",response.data.result.user._id);
      toast.success('Successfully LogeedIn!');
    }else{
      toast.error("Something went Wrong")
    }
 }

  return (
    <div>
      <Header />
      <div className="edit_profile register login">
        <div className="container">
          <div className="row">
            <div className="col-lg-7" />
            <div className="col-lg-5">
              <div className="right_part space-y-20">
                <h1 className="color_white"> Welcome to MeritVerse </h1>
                <p className="color_white" style={{color: 'white !important'}}>
                  Don't have an account yet?
                  <Link to="register"> Register </Link>
                </p>
                <div className="box edit_box w-full space-y-20">
                  <div className="space-y-10">
                    <span className="nameInput">Email </span>
                    <div className="confirm">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter email"
                        value = {email}
                        onChange={(e)=>{setEmail(e.target.value)}}
                      />
                    </div>
                  </div>
                  <div className="space-y-10">
                    <span className="nameInput">Password</span>
                    <div className="confirm">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter your password"
                        value = {password}
                        onChange={(e)=>{setPassword(e.target.value)}}
                      />
                    </div>
                  </div>
                  <Link
                    to="#"
                    className="btn btn-white btn-sm color_green"
                    onClick={notify}>
                    Click to verify
                  </Link>
                  <Link
                    to="/profile"
                    onClick={login}
                    className="btn btn-grad w-full btn-lg">
                    Login to your account

                  </Link>
                  <ToastContainer position="bottom-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
